"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _designLanguage = require("@doordash/design-language");

var _componentLayerManager = require("@doordash/component-layer-manager");

var _ToastContent = _interopRequireDefault(require("./ToastContent"));

var _constants = require("../constants");

var _utils = require("../utils");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DURATION = 225; // toastsToDisplay is a collection of the Toasts that should be displayed on the screen.
// However, in order to give `LayerAnimation` enough time to run the exiting animations
// for the component, we keep a stateful copy of the Toasts in toastsToRender (provided by the parent
// in ToastProvider). We can check if a Toast has been removed from toastsToDisplay, and if it has
// that will change the `in` prop to `false` which triggers the exiting animation.
// Once complete, we then leverage the setsToastsToRender callback to let the parent know
// that we're ready to fully remove the Toast from any top-level states or records.

var ToastsContainer = function ToastsContainer(_ref) {
  var position = _ref.position,
      toastsToDisplay = _ref.toastsToDisplay,
      toastsToRender = _ref.toastsToRender,
      setToastsToRender = _ref.setToastsToRender;

  var handleRemove = function handleRemove(toastId) {
    var updatedToasts = _objectSpread({}, toastsToRender);

    delete updatedToasts[toastId];
    setToastsToRender(updatedToasts);
  };

  return /*#__PURE__*/_react["default"].createElement(_designLanguage.StackChildren, null, Object.entries(toastsToRender).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        toastId = _ref3[0],
        toastProps = _ref3[1];

    return /*#__PURE__*/_react["default"].createElement(_componentLayerManager.LayerAnimation, {
      onExited: function onExited() {
        return handleRemove(toastId);
      },
      key: toastId,
      exitDuration: DURATION,
      styleDefault: {
        transition: "transform ".concat(DURATION, "ms ease-in-out, opacity ").concat(DURATION, "ms linear")
      },
      transition: {
        entering: {
          transform: "translate3d(0%, ".concat((0, _utils.isTopPosition)(position) ? _designLanguage.Spacing.XxSmall : -_designLanguage.Spacing.XxSmall, "px, 0)"),
          opacity: 0
        },
        entered: {
          transform: 'translate3d(0%, 0px, 0)',
          opacity: 1
        },
        exiting: {
          transform: "translate3d(0%, ".concat((0, _utils.isTopPosition)(position) ? _designLanguage.Spacing.XxSmall : -_designLanguage.Spacing.XxSmall, "px, 0)"),
          opacity: 0
        },
        exited: {
          transform: 'translate3d(0%, 0px, 0)',
          opacity: 0
        }
      },
      "in": !!toastsToDisplay[toastId]
    }, /*#__PURE__*/_react["default"].createElement(_ToastContent["default"], _extends({
      toastId: toastId
    }, toastProps, {
      position: position
    })));
  }));
};

ToastsContainer.propTypes = {
  toastsToDisplay: _propTypes["default"].objectOf(_propTypes["default"].shape(_constants.TOAST_CONTENT_PROPTYPES)),
  toastsToRender: _propTypes["default"].objectOf(_propTypes["default"].shape(_constants.TOAST_CONTENT_PROPTYPES)),
  setToastsToRender: _propTypes["default"].func,
  position: _propTypes["default"].oneOf(Object.values(_constants.POSITIONS))
};
var _default = ToastsContainer;
exports["default"] = _default;